const news = [
  {
    title: 'Дорогие клиенты!',
    link: 'дорогие-клиенты',
    date: '27.02.2023',
    preview: 'Мы расширяем географию отделений в Запорожской области. Мы ждём Вас с 27.02.2023 в отделении в г. Бердянск ул. Морская 45Б. С уважением, команда Логистики Таврии',
    text: '<p>Мы расширяем географию отделений в Запорожской области.</p>\n' +
        '\n' +
        '\n' +
        '\n' +
        '<p>Мы ждём Вас с 27.02.2023 в отделении в г. Бердянск ул. Морская 45Б.</p>\n' +
        '\n' +
        '\n' +
        '\n' +
        '<p>С уважением, команда Логистики Таврии</p>\n'
  },
]

export default news
